export default __webpack_public_path__ + "static/media/12.28ae7022.png";